import { render, staticRenderFns } from "./StadiumsTable.vue?vue&type=template&id=6acd87ca&"
import script from "./StadiumsTable.vue?vue&type=script&lang=js&"
export * from "./StadiumsTable.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports